var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIcBus = function SvgIcBus(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M14.003 5.317V4a2.67 2.67 0 0 0-2.667-2.667H4.669A2.67 2.67 0 0 0 2.003 4v1.332l-.051.003A.667.667 0 0 0 1.333 6v1.333A.667.667 0 0 0 2 8h.003v4c0 .49.268.915.664 1.147V14a.667.667 0 0 0 .666.667H4A.667.667 0 0 0 4.667 14v-.667h6.666V14a.667.667 0 0 0 .667.667h.667a.667.667 0 0 0 .666-.667v-.85a1.34 1.34 0 0 0 .67-1.15V8a.667.667 0 0 0 .666-.667V6.041a.7.7 0 0 0-.048-.303c-.135-.325-.423-.403-.618-.421M12.67 12H3.336V8.667h9.334zM7.336 4.667v2.666h-4V4.667zm5.333 0v2.666h-4V4.667zm-8-2h6.667c.49 0 .917.27 1.148.666H3.521a1.33 1.33 0 0 1 1.148-.666"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M5 11.333a1 1 0 1 0 0-2 1 1 0 0 0 0 2M11 11.333a1 1 0 1 0 0-2 1 1 0 0 0 0 2"
  })));
};
export default SvgIcBus;